import React, { useEffect, useState } from 'react';
import "./style.sass";


export function ProgressBar(props) {

    const { progress } = props;

    const [progressAuth, setProgressAuth] = useState(0);

    useEffect(() => {
        if (progress) {
            setProgressAuth(progress);
        }
    }, [progress])


    return (
        <div className='progress-bar'>
            <div className='barra-fondo' style={{ width: `${progressAuth}%`}}>
            </div>
        </div>
    )
}